<template>
  <div id="UrlRedirectDialog">
    <el-dialog :title="title" width="540px" :visible.sync="isVisibleTemp" @close="closeAndclear('urlInfo')">
      <el-form :model="urlInfo" :rules="rules" ref="urlInfo" >
        <el-form-item label="URL编码" :label-width="formLabelWidth" prop="urlCode">
          <el-input class="eb-input panel-body-row-right" v-model="urlInfo.urlCode" auto-complete="off" placeholder="URL编码"></el-input>
        </el-form-item>
        <el-form-item label="版本号" :label-width="formLabelWidth" prop="version">
          <el-input class="eb-input panel-body-row-right" v-model="urlInfo.version" auto-complete="off" placeholder="版本号"></el-input>
        </el-form-item>
        <el-form-item label="跳转到地址" :label-width="formLabelWidth" prop="jumpUrl">
          <el-input class="eb-input panel-body-row-right" v-model="urlInfo.jumpUrl" auto-complete="off" placeholder="跳转到地址"></el-input>
        </el-form-item>
        <el-form-item label="URL描述" :label-width="formLabelWidth" prop="urlDesc">
          <el-input type="textarea" class="eb-textarea" :rows="4" v-model="urlInfo.urlDesc" auto-complete="off" placeholder="URL描述"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="closeAndclear('urlInfo')">关闭</el-button>
        <el-button v-if="urlInfo.operType === 'add'" class="eb-button-group-btn eb-button-orange eb-button-big" @click="addUrlAndUser">确定</el-button>
        <el-button v-else class="eb-button-group-btn eb-button-orange eb-button-big" @click="editUrlAndUser">确定</el-button>
      </div>

    </el-dialog>
  </div>
</template>
<script>
import { saveUrlInfo, editUrlInfo } from '@/services/system-service';
export default {
  props: {
    urlInfo: {
      type: Object
    },
    isVisible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    var checkUrlCode = (rule, value, callback) => {
      let reg1 = /^[0-9a-zA-Z]*$/;
      if (!value) {
        callback();
      } else {
        if (!reg1.test(value)) {
          callback(new Error('只能包含数字字母'));
        } else {
          callback();
        }
      }
    };
    return {
      formLabelWidth: '120px',
      rules: {
        urlCode: [
          { required: true, message: '请输入URL编码', trigger: 'blur' },
          { validator: checkUrlCode, trigger: 'blur' },
          { min: 1, max: 20, message: '长度在1 到 20 个字符', trigger: 'blur' }
        ],
        version: [
          { required: true, message: '请输入版本号', trigger: 'blur' },
          { min: 1, max: 10, message: '长度在1 到 10 个字符', trigger: 'blur' }
        ],
        jumpUrl: [
          { required: true, message: '请输入跳转到地址', trigger: 'blur' },
          { min: 1, max: 300, message: '长度在1 到 300 个字符', trigger: 'blur' }
        ],
        urlDesc: [{ min: 1, max: 300, message: '长度在1 到 300 个字符', trigger: 'blur' }]
      }
    };
  },
  computed: {
    title() {
      if (this.urlInfo.operType === 'add') {
        return '新增URL跳转';
      } else {
        return '修改URL跳转';
      }
    },
    isVisibleTemp: {
      get: function() {
        return this.isVisible;
      },
      set: function(val) {
        this.$emit('update:isVisible', val);
      }
    }
  },
  methods: {
    // 保存
    addUrlAndUser() {
      this.$refs['urlInfo'].validate(async valid => {
        if (valid) {
          this.$root.layout.isLoading = true;
          try {
            let { data } = await saveUrlInfo(this.urlInfo);
            if (data.returnCode === '02') {
              this.$message.error('URL编码和版本号组合重复');
              this.$root.layout.isLoading = false;
              return;
            } else if (data.returnCode === '01') {
              this.isVisibleTemp = false;
              this.$message.success('添加成功');
              this.$emit('onSuccess');
            } else if (data.returnCode === '00') {
            } else {
              this.$message.error('添加失败');
            }
          } catch (error) {
            this.$message.error(error.message);
          }
          this.$root.layout.isLoading = false;
        } else {
          console.log('error submit!!');
        }
      });
    },
    editUrlAndUser() {
      this.buttonLoading = true;
      this.$refs['urlInfo'].validate(async valid => {
        if (valid) {
          this.$root.layout.isLoading = true;
          try {
            let { data } = await editUrlInfo(this.urlInfo);
            if (data.returnCode === '02') {
              this.$message.error('URL编码和版本号组合重复');
              this.$root.layout.isLoading = false;
              return;
            } else if (data.returnCode === '01') {
              this.isVisibleTemp = false;
              this.$message.success('修改成功');
              this.$emit('onSuccess');
            } else if (data.returnCode === '00') {
            } else {
              this.$message.error('修改失败');
            }
          } catch (error) {
            this.$message.error(error.message);
          }
          this.$root.layout.isLoading = false;
        } else {
          console.log('error submit!!');
        }
      });
    },
    closeAndclear(urlInfo) {
      this.isVisibleTemp = false;
      this.$refs[urlInfo].resetFields();
    }
  }
};
</script>
